import { render, staticRenderFns } from "./shopSettings.vue?vue&type=template&id=c3bdaf60&"
import script from "./shopSettings.vue?vue&type=script&lang=js&"
export * from "./shopSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports